<template>
<el-dialog class="my-dialog" custom-class="task-add-list" title="新建任务清单" width="362px" :close-on-click-modal="false" :show-close="false" :visible.sync="currentValue" @opened="opened">
  <div class="wrap-form" v-on:keyup.enter="onSubmit">
    <el-form class="my-form" ref="form" :model="form" :rules="rules" label-width="0">
      <el-form-item label="" prop="title">
        <el-input ref="input" size="large"  :rows="3" v-model="form.title" placeholder="请输入清单标题" clearable></el-input>
      </el-form-item>
    </el-form>

  </div>
  <div slot="footer" class="dialog-footer">
    <span class="cancel text-btn-active" @click="currentValue = false" style="margin-right:30px;">取消</span>
    <wf-button @click="onSubmit" :disabled="!form.title">创建清单</wf-button>
  </div>
</el-dialog>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  name: "",
  props: {
    projectId: {
      type: [Number, String],
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: "", //清单标题
      },
      rules: {
        title: [
          { required: true, trigger: "change", message: "清单标题不能为空" },
          { max: 140, trigger: "change", message: "清单标题不能超过140个字符" }
        ]
      }
    };
  },
  computed: {
    currentValue: {
      get: function () {
        if(this.value) {
          this.$nextTick(() => {
            this.resetForm()
          })
        }
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
  },
  methods: {
    ...mapActions('task/task', ['addChecklist', 'editChecklist']),
    resetForm() {
      this.form.title = "";
      this.form.orderby = 0;
      this.$refs.form.resetFields();
    },
    onSubmit() {
      this.$emit('success', this.form.title)
    },
    opened() {
      this.$refs.input.focus()
    }
  },
};
</script>
<style lang="scss">
.my-dialog {
  .el-dialog__header {
    padding: 24px;
    padding-bottom: 10px;
  }
  .my-form .el-textarea textarea, .my-form .el-input input, .my-form .el-cascader__search-input, .my-form .el-form-item.is-error .el-input__inner {
    background-color: #fff;
  }
  .my-form .el-form-item__error {
    position: relative;
  }
}
</style>
